import React, { Component } from 'react';
import LocationContent from '../organisms/LocationContent';
import IconClose from '../atoms/IconClose';
import IconChevron from '../atoms/IconChevron';
import { Link } from 'react-router-dom';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';


class Location extends Component {

  constructor( props ) {
    super( props );
    this.state = {
      locationId: null,
    }
  }

  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    if( parsed.location ) {
      this.setState({
        locationId: parsed.location,
      });
    }
  }

  render() {
    return (
        <div className="Location">
          <div className="LocationButtons">
            <p><button className="linkStyle hasIcon" onClick={this.props.history.goBack}><IconChevron/><span>Back</span></button></p>
            <p><Link to="/"><IconClose/></Link></p>
          </div>
          <LocationContent location={this.state.locationId}/>
        </div>
    )
  }
}

export default withRouter(Location);